import AppAnalytics from "./AppAnalytics";
export default AppAnalytics;